"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

require("babel-polyfill");

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactRouter = require("react-router");

require("./common/styles/base.scss");

require("../targets/cord_eurofh_teams/fonts.scss");

var _Routes_Cordova = _interopRequireDefault(require("./common/components/Routes_Cordova"));

require("./helpers/Logger");

/**
 * App entry point
 */
// Polyfill
// Libraries
// Base styling
// Font imports
// Routes
// ID of the DOM element to mount app on
var DOM_APP_EL_ID = 'app'; // Render the router

_reactDom["default"].render( /*#__PURE__*/_react["default"].createElement(_reactRouter.Router, {
  history: _reactRouter.hashHistory
}, _Routes_Cordova["default"]), document.getElementById(DOM_APP_EL_ID));